import { Api } from '../api';
import { transaction } from '../endpoints';
import type { TransactionEntity, TransactionSearchParams } from './models';

export class TransactionApi extends Api {
  static getTransactions = (searchParams: TransactionSearchParams, signal?: AbortSignal) =>
    this.post<TransactionSearchParams, TransactionEntity[]>({ url: transaction.getTransactions(), data: searchParams, signal });
}
